import { FunctionComponent, SVGProps, forwardRef } from 'react'
import styled, { css } from 'styled-components'

import { RotateIcon } from '@nx/fire/assets'
import { AnchorProps, FireButton, FireButtonProps } from '@nx/fire/button'

export const ActionPanelItem = forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  ActionPanelItemProps
>(function ActionPanelItem(
  { title, icon, isLoading = false, forceAnchor = true, ...props },
  ref
) {
  return (
    <ActionItem
      {...props}
      variant="ghost"
      forceAnchor={props.href ? forceAnchor : undefined}
      ref={ref}
    >
      <ActionItemIcon
        as={isLoading ? RotateIcon : icon}
        $isLoading={isLoading}
      />
      {title}
    </ActionItem>
  )
})

const ActionItem = styled(FireButton)`
  ${({ theme }) => css`
    color: ${theme.colours.grey['90']};
    margin-bottom: 5px;

    &:hover,
    &:focus {
      color: ${theme.colours.primary.primary};
    }
  `}
`

const ActionItemIcon = styled.svg<{ $isLoading: boolean }>`
  ${({ theme, $isLoading }) => css`
    animation-name: ${$isLoading ? theme.animation.rotate360 : ''};
    animation-duration: 1.8s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    height: 22px;
    margin-right: 4px;
    width: 22px;
  `}
`
export type ActionPanelItemProps = FireButtonProps & {
  title: string
  icon?: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >
  href?: AnchorProps['href']
  isLoading?: boolean
  forceAnchor?: boolean
}
